import BackendService from "@/services/BackendService";

export const namespaced = true;

const user = JSON.parse(localStorage.getItem("user"));

export const state = user
  ? { loggedIn: true, user, profile: null }
  : { loggedIn: false, user: null, profile: null };

export const mutations = {
  LOGIN(state, user) {
    state.loggedIn = true;
    state.user = user;
  },
  LOGIN_ERROR(state, error) {
    state.loggedIn = false;
    state.user = null;
  },
  LOGOUT(state) {
    state.loggedIn = false;
    state.user = null;
  },
  SET_USER(state, user) {
    state.user = user;
  },
  SET_PROFILE(state, profile) {
    state.profile = profile;
  }
};

export const actions = {
  login({ dispatch, commit }, { username, password }) {
    return BackendService.login(username, password)
      .then(user => {
        commit("LOGIN", user);
        return user;
      })
      .catch(error => {
        let notification = {
          type: "error",
          message:
            error.response.data.message ||
            "Er was een fout tijdens het inloggen"
        };
        dispatch("notification/add", notification, { root: true });
        commit("LOGIN_ERROR", error);
        throw error;
      });
  },
  logout({ commit, dispatch }) {
    return BackendService.logout()
      .then(() => {
        commit("LOGOUT");
      })
      .catch(error => {
        let notification = {
          type: "error",
          message: "Uitloggen is mislukt: " + error.message
        };
        dispatch("notification/add", notification, { root: true });
        throw error;
      });
  },
  fetchProfile({ commit }) {
    return BackendService.getUserProfile()
      .then(({ data }) => {
        commit("SET_PROFILE", data);
      })
      .catch(error => {
        console.log("There was an error", error);
      });
  },
  updateUserProfile({ commit }, profile) {
    return BackendService.updateUserProfile(profile).then(({ data }) => {
      commit("SET_PROFILE", profile);
      commit("SET_USER", data);
      return user;
    });
  }
};

export const getters = {
  isGuest: state => {
    return !state.loggedIn;
  },
  getProfile: state => {
    return state.profile;
  }
};
